import { AxiosError } from "axios"

export const getErrorStatus = (error: unknown): number | undefined => {
  if (typeof error === "object" && error !== null) {
    const typedError = error as { status?: number; response?: { status?: number } }
    return typedError.status ?? typedError.response?.status
  }
  return undefined
}

export const getErrorMessage = (error: unknown): string => {
  if (error instanceof AxiosError) {
    const data = error.response?.data as
      | {
          message?: string
          error?: string
          msg?: string
          err?: string | { msg?: string }
        }
      | undefined
    // Check nested err.msg first (e.g. {err: {msg: "Bakiye yetersiz"}, msg: "Error"})
    const nestedErrMsg =
      typeof data?.err === "object" && data?.err !== null ? data.err.msg : undefined
    return (
      nestedErrMsg ||
      data?.message ||
      data?.error ||
      data?.msg ||
      (typeof data?.err === "string" ? data.err : undefined) ||
      error.message
    )
  }

  if (error instanceof Error) {
    return error.message
  }

  if (typeof error === "object" && error !== null) {
    const typedError = error as {
      message?: string
      error?: string
      response?: { data?: { message?: string; error?: string } }
    }

    return (
      typedError.response?.data?.message ||
      typedError.response?.data?.error ||
      typedError.message ||
      typedError.error ||
      safeStringify(error)
    )
  }

  if (typeof error === "string") {
    return error
  }

  return safeStringify(error)
}

const safeStringify = (value: unknown): string => {
  try {
    return JSON.stringify(value)
  } catch {
    return String(value)
  }
}

export const getErrorResponse = (error: unknown): unknown => {
  if (error instanceof AxiosError) {
    return (
      error.response?.data?.error ||
      error.response?.data?.msg ||
      error.response?.data?.err ||
      error.message
    )
  }
  if (error instanceof Error) {
    return error.message
  }
  if (typeof error === "string") {
    return error
  }
  try {
    return JSON.stringify(error)
  } catch {
    return String(error)
  }
}

export const isAbortError = (error: unknown): boolean => {
  if (typeof error === "object" && error !== null) {
    const typedError = error as { name?: string; code?: string }
    return typedError.name === "AbortError" || typedError.code === "ERR_CANCELED"
  }
  return false
}

export const isAxiosTimeoutError = (error: unknown): boolean => {
  if (typeof error === "object" && error !== null) {
    const typedError = error as { code?: string }
    return typedError.code === "ECONNABORTED"
  }
  return false
}

export const buildTimeoutError = (message: string): Error => new Error(message)
